import React from "react"
import useSWR from "swr"
import { apiV2 } from "../../repositories/repository"
import useSWRMutation from "swr/mutation"
import { CompactTable } from "@table-library/react-table-library/compact"
import { UserDto } from "../../sdk"
import { formatDate } from "../../utils/datetime"
import { useTheme } from "@table-library/react-table-library/theme"
import { getTheme } from "@table-library/react-table-library/mantine"

const Demo = () => {
  const theme = useTheme(getTheme())
  const [newLoginCode, setNewLoginCode] = React.useState('')
  const {
    data: users,
    mutate: mutateUsers,
  } = useSWR(
    'api.questionerAnswer.getVitalisUsers',
    () => apiV2.questionerAnswer.getVitalisUsers(),
    {revalidateOnFocus: false}
  )

  const {
    trigger: createUser,
  } = useSWRMutation(
    'api.userAdmin.getVitalisUsers',
    () => apiV2.userAdmin.createVitalisUser(),
  )
  const createNewUser = async () => {
    const userCode = await createUser()
    setNewLoginCode(userCode.code)
    mutateUsers()
  }

  const tableColumns = [
    {label: 'id', renderCell: (item: UserDto) => item.id},
    {
      label: 'Login code',
      renderCell: (item: UserDto) => item.loginCode?.code
    },
    {
      label: 'Tests passed',
      renderCell: (item: any) => item.amount || 0
    },
    {
      label: 'Creation time',
      renderCell: (item: UserDto) => formatDate(item.createdAt)
    }
  ]

  return <>
    <div className="card-box">
      <button onClick={createNewUser} className="g_btn g_btn--primary">
        New Vitalis user
      </button>
      {!!newLoginCode && <p>New user code: <strong>{newLoginCode}</strong></p>}
    </div>
    <div className="card-box">
      <CompactTable
        columns={tableColumns}
        data={{nodes: users || []}}
        theme={theme}
      />
    </div>
  </>
}
export default Demo
